import type { HelpFile } from '../../types/help'
import { OwnersSectionTestIds } from '../../../testids/OwnersSectionTestIds'

export const ownersSectionHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [OwnersSectionTestIds.sectionOwners]:
      'Verantwortliche Parteien und ihre jeweiligen Verantwortlichkeiten.',
    [OwnersSectionTestIds.addOwnerForm]: null,
    [OwnersSectionTestIds.btnAddOwner]:
      'Neuen Eigentümer zu dieser Entität hinzufügen.',
    [OwnersSectionTestIds.btnCancelAddOwner]: null,
    [OwnersSectionTestIds.btnSaveAddOwner]: null,
    [OwnersSectionTestIds.colOwnerActions]: null,
    [OwnersSectionTestIds.colOwnerParty]:
      'Partei, die diese Entität besitzt oder dafür verantwortlich ist.',
    [OwnersSectionTestIds.colOwnerResponsibility]:
      'Art der Verantwortung — Fachverantwortlicher, technischer Verantwortlicher oder Steward.',
    [OwnersSectionTestIds.colOwnerValidFrom]:
      'Datum, ab dem diese Verantwortungszuweisung gilt.',
    [OwnersSectionTestIds.colOwnerValidTo]:
      'Datum, an dem diese Verantwortungszuweisung endet, sofern vorhanden.',
    [OwnersSectionTestIds.comboboxAddOwnerParty]:
      'Partei suchen, die als Eigentümer zugewiesen werden soll.',
    [OwnersSectionTestIds.selectAddOwnerResponsibility]:
      'Art der Verantwortung des neuen Eigentümers. Die verfügbaren Optionen stammen aus dem entitätsspezifischen Verantwortlichkeits-Lookup; ist nur eine Rolle konfiguriert, wird dieses Feld ausgeblendet und die Rolle automatisch gesetzt.',
    [OwnersSectionTestIds.optionResponsibilityPrefix()]: null,
    [OwnersSectionTestIds.responsibilityLookupMissingError]: null,
  },
}
